package it.neckar.lizergy.model.http

import it.neckar.open.annotations.Effective
import it.neckar.open.http.Url
import it.neckar.open.http.UrlPattern
import kotlin.uuid.Uuid

/**
 * Process states endpoints interface
 *
 * Note: @Effective annotations on properties use relative paths that will be combined with baseUrl
 */
interface ProcessStatesEndpoints : Endpoints {
  @Effective("process-states")
  val processStates: UrlPattern.Relative0
    get() = baseUrl + "process-states"

  @Effective("process-states/all")
  val AllProcessStates: UrlPattern.Relative0
    get() = processStates + "all"

  fun allProcessStatesUrl(): Url.Relative = AllProcessStates.resolve()

  @Effective("process-states/{uuid}")
  val ProcessStatesForComponent: UrlPattern.Relative1
    get() = processStates + EndpointsParameters.Uuid

  fun processStatesForComponentUrl(uuid: Uuid): Url.Relative = ProcessStatesForComponent.resolve(uuid)

  @Effective("process-states/add-multiple")
  val addMultipleProcessStates: UrlPattern.Relative0
    get() = processStates + "add-multiple"

  @Effective("process-states/duplicate")
  val duplicateProcessStates: UrlPattern.Relative0
    get() = processStates + "duplicate"

  @Effective("process-states/reassign")
  val reassignProcessStates: UrlPattern.Relative0
    get() = processStates + "reassign"

  fun reassignProcessStatesUrl(): Url.Relative = reassignProcessStates.resolve()
}
